/**
 *Created by jmmartinez on 24/09/2020
 * 30/09/2020 v2.0  Cambiado a framework2
 * 01/10/2020 v2.1 Añadida gestión de coloreador de columna.
 * 05/10/2020 v2.2 Añadido buscador.
 *                 Añadida funcion selectRow
 *                 Añadida la función  getDatosConRowSeleccionado para inyectar el campo filaSeleccionada en los datos que van al formatter.
 * 06/10/2020 v2.3 Modificada la función getDatosConRowSeleccionado para cuando elementoSeleccionado==null
 * 07/10/2020 V2.4 Asignado a <DataGrid>  minWidth: 10, porque por defecto es 50.
 * 16/10/2020 V2.4 Añadida propiedad estilizadorRow y se usa para pasar el estilizador a la columna por defecto.
 * 20/10/2020 V2.5 Gestión de mostrarFilaActiva y uso correcto en transformarColumnas
 *
 * 29/10/2020 V2.6 Añadida propiedad para ocultar el encabezado: mostrarHeaderRow
 * 04/11/2020 v2.7 Añadida propiedad estilo y su manejo en Render.
 *                 Modificado el tamaño del row por defecto
 * 09/11/2020 v2.8 Añadida propiedad onSelectedRowsChanged
 * 25/11/2020 v2.9 Añadida propiedad rowHeight
 *
 *
 *
 *
 *
 *
 *
 *
 *
 * 22/11/2020 v2.10 Añadiendo editabilidad.
 *                   La columna es editable si tiene la propiedad editable el grid y la columna.
 *                   En el metodo transformarPropiedades:
 *                              añadimos mostrarFilaActivaReal si hay que mostrar la fila activa. Y a Falso si es editable el grid.
 *                              añadimos mostrarCeldaActiva si es editable el grid.
 *                   Añadida propiedad onRowModificada, para que FormularioGrid llame al servicio del servidor y guarde el elemento.
 *
 * 22/12/2020 v2.11 Comentado shouldComponentUpdate
 *                 Comenzado el uso de los editores en las columnas
 * 11/02/2021 v2.12 Añadiendo soporte para Configuracion
 * 19/02/2021 v2.13 Modificaciones (marcadas con ###) para seleccionar sólo el row y no la fila sea o no editable, ya que da problemas seleccionar la fila.
 *                  Añadido en método transformarColumnas:    onAccion: columnaOriginal.onAccion,
 * 29/05/2021 v2.16 Añadida funcion modificadorValorCelda para usarla posterioremente en el Formatter
 * 25/06/2021 v2.14 Modificado el método transformarColumnas, añadiendo a newColuma el icon ->  icon: columnaOriginal.icon,

 * 01/07/2021 v2.15 Añadido el evento onDatosFiltradosCambiados y onDatosORdenadosCambiados.
 * 05/07/2021 v2.16 Añadida opcion de filtroTipos
 * 16/07/2021 v2.17 En el render de SelectorOpciones añadimos valorInicial={{codigo: 99, nombre: "Todos"}}
 * 20/07/2021 v2.18 Añadida opcion de filtroTipos2

 * 29/07/2021 v2.50 Añadido evento onGridRowsChange para soporte de version "7.0.0-canary.49"
 *                  Anulado onGridRowsUpdated
 *                  Añadido onColumnCellKeyUp
 *                  Asignamos siempre el editor CadenaEditor si es una column aeditable.
 *                  Creado renderizador de editor de Color.
 *                  Añadido onCloseColorEditor
 *                  !Añadido metodo selectedCellChange
 *                  Creado renderizado de Foreign
 *                  Añadido onForeignAceptado
 *                  Añadida propiedad urlServicioRestful
 *                  En transformarColumnas, añadimos el campo clase desde la columnaOriginal.
 *                  Añadida propiedad usarFiltros35
 * 02/08/2021 v2.51 Modificado evento selectedCellChange.
 *                  Modificado evento rowClick para quitar rowIdx.
 *                  Nuevo método getDatosConRowIdx para inyectar rowIdx en los datos.
 *                  Nuevo metodo onSortColumns que sustituye a sortRows en la 7.0.0.Beta
 * 03/08/2021 V2.52 Añadido método gridEditable y su uso
 *                  Añadido método onKeyUpTabla. Corregido para que el evento devuelva onRowSelectedReturn(this.state.elementoSeleccionado)
 *                  En render, cambiado "estilo" de state a props.
 * 06/08/2021 v2.53 Añadida dependencia con el REDUX definicionesif
 *                  En componentDidMount leemos la configuración del REDUX y no de la BDD
 *                  En getDerivedStateFromProps, sólo cambiamos el estilo si viene distinto de undefined.
 *                  Para poder usar la propiedad ref de GridRDG, hemos tenido que añadirle el parametro wrappedComponentRef={this.refGrid}
 * 09/08/2021 v2.54 Definicionif adecuado a nueva versión:
 *                      En componentDidUpdate usamos la nueva función getConfiguracionGridFromConfiguracionRedux.
 *                      Modificado onAceptarConfiguracion.
 * 10/08/2021 v2.55 Añadida propiedad funcRefreshData, un enlace a la función refreshData de FormularioGrid para provocar un refresco completo.
 * 18/03/2022 v2.56 Modificada la función filtrar: cambiado filtrarConTodosCampos por el nuevo filtrarConCamposGridConfigColumnas
 *
 *
 *
 * 03/05/2022 v2.60 Unificación Sidemur-Planifikator
 * 31/05/2022 v2.61 En transformarColumnas se añade * al título de las columnas editables.
 *                  Añadido editorExterno:
 * 03/06/2022 v2.62 En rowGuardada, modificamos la llamada a onSelectRow quitando el parámetro rowIndex
 * 07/06/2022 v2.63 Añadidas propiedads  onValorBuscadorCambiado y valorBuscador en properties.
 *                  En componentDidMount añadimos this.onFilterChange(valorBuscador);
 *                  En  onGridRowsChange añadido último parámetro noGuardarEnBDD
 * 26/07/2022 v2.64 Añadida propiedad mostrarNumeracion.
 * 27/07/2022 v2.65 Añadida propiedad estilizadorRow en la columna
 * 14/09/2022 v2.66 Añadidas las propiedades: showFiltroClick, filtroClickTitulo, onChangeFiltroClick, filtroClickValor
 *                  Modificado render para pintar el Click junto a Buscar.
 *                  Modificado getDerivedStateFromProps para tener en cuenta los cambios en la propiedad filtroClickValor
 *
 * 26/09/2022 v2.67 En el metodo SelectRow, modificamos los parametros de la llamada a onSelectedRow(elemento, row)
 *
 * 27/01/2023 v2.68 En transformarColumnas: Añadido ocultarCeros en newColumna.
 * 28/02/2023 v2.69 Añadida funcionalidad de copiar al portapapeles
 * 21/04/2023 v2.70 Añadida Edición Externa de campos de tipo SINO.
 * 24/04/2023 V2.71 Añadida propiedad mostrarModificar y su gestión.
 *                  Añadido método onModificar
 * 25/04/2023 V2.72 Añadida propiedad mostrarEliminar y su gestión.
 *                  Añadido método onEliminar
 *
 * 29/04/2023 V2.73 En el método copiarPortapapeles, calculamos la idx de la columna teniendo en cuenta que hay que restar si se muestra la columna de numeración o de modificar
 *                  En el evento dobleClick, modificar el cálculo de la columna, teniendo en cuenta si hay columna modificar o numeración
 * 09/05/2023 V2.74 En el metodo copiarPortapapeles, obtenemos el valor usando getValorPropiedad, para que obtenga correctamente el camino por los Foreigns.
 * 18/05/2023 v2.75 En el método transformarColumnas añadido listaColores.
 *
 *
 * 24/05/2023 v2.76 En método transformarColumnas, añadido el campo onTooltip y el campo mostrarTooltip.
 * 29/05/2023 v2.77 En el metodo onColumnResize, aplicamos la corrección de idX de editable, mostrarNumeracion y mostrarModificar
 * 30/05/2023 v2.78 En el metodo onModificar, cuando llamamos a onSelectedRow, el tercer parámetro es un callback, al que se llama al terminar.
 *                  Nos hace falta para asegurarnos que se llama a onAccion cuando se haya terminado el onSelectedRow.
 * 06/06/2023 v2.79 En el método onGridRowsChange: Modificada la forma de obtener el campo.
 *                                                 Si se trata de un campo Foreign de modoCargaBDD, el nuevo valor del campo se obtiene con modoCargaBDDCampoOrigenMostrar.
 *
 * 13/07/2023 v2.80 Añadida la propiedad desdeMovil: PropTypes.bool
 *                  Creado el método mostrarPopover, al que se llama desde Click de Formatter si existe la propiedad onTooltip.
 *                                                  Tenemos que pasar el método en las propiedades de la columna para poder llamarlo desde Click.
 *                  En transformarColumna, añadimos la propieded mostrarPopover: this.mostrarPopover.
 *
 * 29/05/2024 v2.90 Añadido en <Datagrid el className={"datagrid_elemento"}
 *                  En transformarColumnas, si es editable y tiene editor externo no dejamos escribir: if (usaEditorExterno(columnaOriginal.tipo)) { editableReal= false;
 *
 *
 * 07/06/2024 v2.91 Añadido en dobleClick, si está activo mostrarChecksSeleccion, restamos uno: idxReal-=1;
 *
 * 20/06/2024 v2.92 Ampliado el tamaño de las columnas "E" a 30
 * 16/09/2024 v2.93 Creada la propiedad NoFocusInicial, para evitar que el foco se ajuste en el edit de búsqueda
 * 08/01/2025 v2.94 En TransformarColumna, modificamos la gestión de ordenable
*/

import React from 'react'
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import DataGrid, {SelectColumn, } from 'react-data-grid';
import "../resources/css/datagrid.css";
import {getFormatter} from "./Formatters";
import {ordenarConCampo} from "../ej2/utils/SortUtils";
import {primerElementoConValorPropiedad, posPrimerElementoConValorPropiedad} from "../ej2/utils/ArrayUtils";
import {Checkbox, Dialog, FormGroup, Icon, InputGroup, Button, Intent,  Popover, Classes} from "@blueprintjs/core";
import {filtrarConTodosCampos, filtrarConNombreCampo, filtrarConCamposGridConfigColumnas} from "../ej2/utils/FilterUtils";
import {getCampoDeForeign, getRaizForeign, getCampoForeignCodigo} from "../ej2/utils/ForeignUtils";
import {compararObjetos, getValorPropiedad} from "../ej2/utils/ObjectUtils";
import {
    CELLTIPO_CADENA,
    CELLTIPO_COLOR,
    CELLTIPO_ESTADOROW,
    CELLTIPO_FECHA, CELLTIPO_FOREIGN,
    CELLTIPO_IMAGENLISTA,
    CELLTIPO_LISTA,
    CELLTIPO_PERSONALIZADO,
    CELLTIPO_SINO,
    CELLTIPO_MODIFICARROW,
    CELLTIPO_ELIMINARROW, CELLTIPO_CADENAFOREIGN,
} from "../ej2/UI/TiposCeldas";
import {getCellEditor} from "./CellEditors";

import {getConfiguracionGridFromConfiguracionRedux} from "../ej2/utils/ConfiguracionInterfaceUtils";
import ConfiguracionGrid from "../ej2/UI/ConfiguracionGrid";
import {transformar} from "./Transformadores";
import SelectorOpciones from "../ej2/UI/SelectorOpciones";
import EditorExterno, {usaEditorExterno, onListaImagenImagenCambiada} from "./EditorExterno";
import {
    BOTONERA_ACCION_MODIFICAR,
    BOTONERA_ACCION_ELIMINAR,
    BOTONERA_ACCION_ELIMINARDESDEGRID
} from "../ej2/UI/FormularioBotonera";

export const EDITOREXTERNO_COLOR = 'EDITOREXTERNO_COLOR';
export const EDITOREXTERNO_FOREIGN = 'EDITOREXTERNO_FOREIGN';
export const EDITOREXTERNO_LISTA= 'EDITOREXTERNO_LISTA';
export const EDITOREXTERNO_PERSONALIZADO= 'EDITOREXTERNO_PERSONALIZADO';
export const EDITOREXTERNO_BOOLEANO= 'EDITOREXTERNO_BOOLEANO';

class GridRDG extends React.Component {


    constructor(props) {
        super(props)

        this.state = {
            estilo: props.estilo ? props.estilo : {height: '370px'},

            sortDirection: null,
            sortColumn: null,
            selectedRowsKeys: new Set(),
            selectedRowKeysOld: null,
            selectedRow: null,
            valorBuscador: this.props.valorBuscador,
            enableHeaderFilters: false,
            elementoSeleccionado: null,
            filters: {},
            minColumnWidth: 30,
            rowHeight: 25, //Alto de cada línea
            maxRowsVisibles: 20, //Número de líneas visibles
            columnas: props.columnas,
            mostrarChecksSeleccion: props.mostrarChecksSeleccion,
            altoGrid: 370,

            cellSelected: null,
            mostrarEditorExterno: null,
            editorExternoColumn: null,
            editorExternoObjeto: null,

            filtroClickValor: false,
            contenidoPopover: null,

            rowHeights: new Map(), // guarda el alto calculado por fila
        }

        this.refTabla = React.createRef();
        this.resourcesImages = require.context('../resources/images/', true);
        this.refBuscador= React.createRef();
        //this.focusBuscadorInicial= true;
        this.focusBuscadorInicial= !props.noFocusInicial || !Boolean(props.noFocusInicial);
        this.anchosColumnas= {}; //No lo ponemos en el state para evitar repintados adicionales
        this.algunaColumnaAnchoModificado= false;

        //console.log(" <<<<<<< GRIDRDG CONSTRUCTOR >>>>>");
        //console.log("columnas: ", props.columnas);
    }

    componentDidMount() {
        const {usuario, ifid, definicionesif} = this.props;
        const {estilo, valorBuscador} = this.state;
        //console.log(" GRID RDG COMPONENTE DID MOUNT");

        if (ifid && usuario && definicionesif && definicionesif.definicionesif) {
            let configuracion= getConfiguracionGridFromConfiguracionRedux(definicionesif.definicionesif, ifid, this.props.columnas);
            if (configuracion){
                let newEstilo= Object.assign(estilo, {height: configuracion.alto + 'px'});
                //console.log("columnas: ", configuracion.columnas);
                this.setState({columnas: configuracion.columnas, altoGrid: configuracion.alto, estilo: newEstilo});

                //console.log(" <<<<<<< GRIDRDG componentDidMount >>>>>");
                //console.log("columnas: ", configuracion.columnas);
            }
        }

        if (valorBuscador && valorBuscador != "")
            this.onFilterChange(valorBuscador);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.elementoSeleccionado != this.elementoSeleccionado)
            this.elementoSeleccionado= {...prevProps.elementoSeleccionado};
        if (this.focusBuscadorInicial === true && this.refBuscador && this.refBuscador.current) {
            this.focusBuscadorInicial= false;
            this.refBuscador.current.focus();
        }
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        //Si hay algún cambio en las props, devolvemos el nuevo objeto y eso provoca una llamada a DidUpdate
        //No podemos guardar en el state directamente porque es un método estático
        const newState = {};
        //console.log("DERIVED:");

        if(nextProps.datos !== prevState.datosIniciales){
            //console.log("Cambiados los datos:");
            newState.datosIniciales= nextProps.datos
            newState.datosOrdenados = nextProps.datos;
            newState.datosFiltrados = nextProps.datos;
        }

        /* #### quitado para que funcione definicionIF
        if(nextProps.columnas !== prevState.columnas){
            newState.columnas= nextProps.columnas;
        }
        */

        /* OJO EN SIDEMUR SÍ ESTÁ
        if(nextProps.elementoSeleccionado !== prevState.elementoSeleccionado) {
            newState.elementoSeleccionado = nextProps.elementoSeleccionado;
        }
        */

        //Si han cambiado los datos o el elemento seleccionado, fijamos de nuevo la rowSeleccionada
        /*
        if(nextProps.elementoSeleccionado !== prevState.elementoSeleccionado ||
            nextProps.datos !== prevState.datosIniciales
        ) {
            let elementoSeleccionado= nextProps.elementoSeleccionado ? nextProps.elementoSeleccionado : prevState.elementoSeleccionado;
            let datos = newState.datosOrdenados ? newState.datosOrdenados : prevState.datosOrdenados;
            if (elementoSeleccionado && datos) {
                //Buscamos que row le toca:
                //Buscamos en el newState por si se hubieran cmabiado los datos, si no en emprevState
                let row = datos && datos.length > 0 ?
                    getPosElementoConNombreCampo(datos, "codigo", elementoSeleccionado.codigo) :
                    -1;
                newState.cellSeleccionada = {rowIdx: row, idx: 0};
            }
        }
        */

        //Sólo se cambia si contiene algo
        if(nextProps.estilo !== prevState.estilo){
            if (nextProps.estilo)
                newState.estilo= nextProps.estilo;
        }
        if(nextProps.filtroClickValor != prevState.filtroClickValor){
            if (nextProps.filtroClickValor)
                newState.filtroClickValor= nextProps.filtroClickValor;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;


    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES STANDARD DE LA BOTONERA EN ICONOS
    //------------------------------------------------------------------------------------------------------------------

    onModificar= (objeto) => {
        const {onSelectedRow, onModificar} = this.props;
        let elementoSeleccionado= objeto;
        onSelectedRow && onSelectedRow(elementoSeleccionado, null, (objeto) => {
            this.setState({elementoSeleccionado: elementoSeleccionado}, () => { onModificar && onModificar(BOTONERA_ACCION_MODIFICAR, elementoSeleccionado)});
        });
      }


    onEliminar= (objeto) => {
        const {onSelectedRow, onEliminar} = this.props;
        let elementoSeleccionado= objeto;
        onSelectedRow && onSelectedRow(elementoSeleccionado);
        this.setState({elementoSeleccionado: elementoSeleccionado}, () => { onEliminar && onEliminar(BOTONERA_ACCION_ELIMINARDESDEGRID, elementoSeleccionado)});
    }

    //------------------------------------------------------------------------------------------------------------------
    // PREPARACION DE COLUMNAS
    //------------------------------------------------------------------------------------------------------------------

    transformarColumnas = (columnasOriginales, resourcesImages) => {
        const {mostrarChecksSeleccion, estilizadorRow, mostrarFilaActiva, nivel,
            modificadorValorCelda, ordenable, onDobleClick,
            editable, mostrarNumeracion,
            usuario,
            mostrarModificar, mostrarEliminar} = this.props;

        //console.log("XXX transformarColumnas");
        //console.log("mostrarChecksSeleccion: ", mostrarChecksSeleccion);
        //console.log("columnasOriginales: ", columnasOriginales);

        let newColumnas = [];
        if (Boolean(mostrarChecksSeleccion))
            newColumnas.push(SelectColumn);


        if (editable || mostrarNumeracion) {
            newColumnas.push( { key: "estadoRow", name: "E", minWidth: 10, width: 30, tipo: CELLTIPO_ESTADOROW, resizable: false,
                                formatter(props){ return getFormatter(props, resourcesImages); }
            } );
        }

        if (mostrarModificar){
            newColumnas.push( { key: "modificarRow", name: "M", minWidth: 10, width: 24, tipo: CELLTIPO_MODIFICARROW, resizable: false,
                onModificar: this.onModificar,
                formatter(props){ return getFormatter(props, resourcesImages); }
            } );
        }


        if (columnasOriginales) {
            columnasOriginales.forEach((columnaOriginal) => {
                let ordenableReal= ordenable == null || Boolean(ordenable);
                if (ordenableReal)
                    ordenableReal= columnaOriginal.ordenable == null || Boolean(columnaOriginal.ordenable);
                //console.log("ordenableReal: ", ordenableReal);
                if (ordenable != undefined && !Boolean(ordenable))
                    ordenableReal= false;
                //console.log("ordenableReal: ", ordenableReal);



                //let estilizador= columnaOriginal.estilizador ? columnaOriginal.estilizador : estilizadorRow;
                let editableReal= editable ? columnaOriginal.editable ? true : false : false;
                let mostrarFilaActivaReal= false;
                let mostrarCeldaActivaReal= true;

                //Si es Editable ponemos * tras el nombre.
                //Si es editable por editorExterno ponemos **, indicando el doble click.
                //console.log("columnaOriginal: ", columnaOriginal);
                let tituloReal= columnaOriginal.titulo;
                if (editableReal) {
                    if (usaEditorExterno(columnaOriginal.tipo)) {
                        editableReal= false; //AÑadido para que no se pueda escribir
                        tituloReal += "**";
                    }
                    else
                        tituloReal += "*";
                }

                //Añadimos al mapa de anchos
                //Añadimos la condición !this.anchosColumnas[index] para que sólo se inicialice en la primera pasada por aqui.
                if (usuario && !this.anchosColumnas[columnaOriginal.campo])
                    this.anchosColumnas[columnaOriginal.campo] = columnaOriginal.ancho;


                //console.log("GRIDRDG - Transformar columna:");
                //console.log(columnaOriginal.campo, " -> ", columnaOriginal.ancho);

                let newColumna = {
                    key: columnaOriginal.campo,
                    name: tituloReal,
                    width: columnaOriginal.ancho,
                    minWidth: 10,
                    tipo: columnaOriginal.tipo,
                    resizable: true,
                    imagenes: columnaOriginal.imagenes,
                    sortable: ordenableReal,
                    frozen: columnaOriginal.frozen,
                    estilizador: columnaOriginal.estilizador,
                    estilizadorRow: estilizadorRow,
                    coloreador: columnaOriginal.coloreador,
                    //mostrarFilaActiva: mostrarFilaActiva != undefined ? mostrarFilaActiva : true,
                    mostrarFilaActiva: mostrarFilaActivaReal,
                    mostrarCeldaActiva: mostrarCeldaActivaReal,
                    onAccion: columnaOriginal.onAccion,
                    icon: columnaOriginal.icon,
                    modificadorValorCelda: modificadorValorCelda,
                    formatter(props){
                          return getFormatter(props, resourcesImages);
                    },
                    editable: editableReal,
                    editor: editableReal ? getCellEditor(columnaOriginal.tipo) : null, //Camino abandonado

                    onColumnCellKeyUp: this.onColumnCellKeyUp,
                    clase: columnaOriginal.clase,
                    valores: columnaOriginal.valores,

                    //onDobleClick: onDobleClick,
                    onDobleClick: this.dobleClick,
                    editorExterno: columnaOriginal.editorExterno,
                    ocultarCeros: columnaOriginal.ocultarCeros,

                    listaColores: columnaOriginal.listaColores,

                    onTooltip: columnaOriginal.onTooltip,
                    mostrarTooltip: columnaOriginal.mostrarTooltip,
                    mostrarPopover: this.mostrarPopover,

                    onCalcularComponentesCelda: columnaOriginal.onCalcularComponentesCelda
                }

                if (columnaOriginal.tipo == CELLTIPO_IMAGENLISTA)
                    newColumna.resourcesImages= resourcesImages;


                //console.log("newColumna: ", newColumna);
                newColumnas.push(newColumna);
            });
        }

        if (mostrarEliminar){
            newColumnas.push( { key: "eliminarRow", name: "E", minWidth: 10, width: 24, tipo: CELLTIPO_ELIMINARROW, resizable: false,
                onEliminar: this.onEliminar,
                formatter(props){ return getFormatter(props, resourcesImages); }
            } );
        }


        return newColumnas;
    }

    //------------------------------------------------------------------------------------------------------------------
    // SORT
    //------------------------------------------------------------------------------------------------------------------

    onSortColumns = (newSortColumns) => {
        const {datosIniciales, columnas, datosFiltrados, sortColumns} = this.state;

        let campo= null;
        let direccion= "ASC";
        let createdSortColumns= [];
        if (newSortColumns.length > 0) {
            campo= newSortColumns[0].columnKey;
            direccion = newSortColumns[0].direction;
            createdSortColumns= newSortColumns;
        }
        else{
            //Aqui viene vacío usamos la SortColumn que había en el status y le invertimos el orden.
            if (sortColumns.length > 0){
                campo= sortColumns[0].columnKey;
                direccion = sortColumns[0].direccion === "ASC" ? "DESC" : "ASC";
                createdSortColumns=[{columnKey: campo, direction: direccion}];
            }
        }

        //Ordenación efectiva y guardado en registro:
        if (campo){
            let columnaOrden = primerElementoConValorPropiedad(columnas, "campo", campo);
            let datos = datosFiltrados ? datosFiltrados : datosIniciales;
            let datosOrdenados = ordenarConCampo(datos, columnaOrden, direccion);
            this.setState({datosOrdenados: datosOrdenados, sortColumns: createdSortColumns});
        }
    }

    //------------------------------------------------------------------------------------------------------------------
    // TECLAS GENERAL
    //------------------------------------------------------------------------------------------------------------------

    onKeyUpTabla = (event) => {
        switch (event.keyCode) {
            case 13:
                const {onRowSelectedReturn} = this.props;
                if (onRowSelectedReturn && !this.gridEditable()) {
                    onRowSelectedReturn && onRowSelectedReturn(this.state.elementoSeleccionado);
                }
                break;
        }
    }


    //------------------------------------------------------------------------------------------------------------------
    // DOBLE CLICK
    //------------------------------------------------------------------------------------------------------------------

    dobleClick= (celda) => {

        const {onDobleClick, columnas,
            editable, mostrarNumeracion, mostrarModificar, mostrarChecksSeleccion} = this.props;


        console.log("¡¡¡¡ onDobleClick");
        console.log("celda: ", celda);
        console.log("columnIdx:", celda.columnIdx);
        console.log("columnKey:", celda.columnKey);
        console.log("columnas: ", columnas);


        let idxReal= celda.columnIdx;
        if (editable || mostrarNumeracion)
            idxReal-=1; //Si está la columna de la numeración, la columna real es uno menos.
        if (mostrarModificar)
            idxReal-=1; //Si se muestra la columna con el icono de modificar, la columna real es uno menos.
        if (mostrarChecksSeleccion)
            idxReal-=1; //Si se muestra la columna con los checks, la columna real es uno menos.

        //let columna= columnas[celda.columnIdx-1];
        let columna= columnas[idxReal];
        console.log("columna: ", columna);

        if (Boolean(columna.editable) ){
            let objeto= celda.objeto;
            switch(celda.tipo){
                case CELLTIPO_CADENAFOREIGN:
                    this.setState({mostrarEditorExterno: EDITOREXTERNO_FOREIGN,  editorExternoColumn: columna, editorExternoObjeto: objeto});
                    break;
                case CELLTIPO_LISTA:
                    this.setState({mostrarEditorExterno: EDITOREXTERNO_LISTA,  editorExternoColumn: columna, editorExternoObjeto: objeto});
                    break;
                case CELLTIPO_COLOR:
                    this.setState({mostrarEditorExterno: EDITOREXTERNO_COLOR,  editorExternoColumn: columna, editorExternoObjeto: objeto});
                    break;
                case CELLTIPO_FOREIGN:
                    this.setState({mostrarEditorExterno: EDITOREXTERNO_FOREIGN,  editorExternoColumn: columna, editorExternoObjeto: objeto});
                    break;
                case CELLTIPO_PERSONALIZADO:
                    this.setState({mostrarEditorExterno: EDITOREXTERNO_PERSONALIZADO,  editorExternoColumn: columna, editorExternoObjeto: objeto});
                    break;
                case CELLTIPO_SINO:
                    this.setState({mostrarEditorExterno: EDITOREXTERNO_BOOLEANO,  editorExternoColumn: columna, editorExternoObjeto: objeto});
                    break;
                default: break;
             }
        }
        onDobleClick && onDobleClick(celda);
    }

    //------------------------------------------------------------------------------------------------------------------
    // FILTRO
    //------------------------------------------------------------------------------------------------------------------

    filtrar= (newValorBuscador, newValorSelectorTipo, newValorSelectorTipo2) => {
        const {datosIniciales} = this.state;
        const {columnas, filtroTipoCampoElemento, filtroTipo2CampoElemento, onDatosFiltradosCambiados} = this.props;

        /*
        console.log("FILTRAR:")
        console.log("datosIniciales: ", datosIniciales);
        console.log("newValorBuscador: ", newValorBuscador);
        console.log("newValorSelectorTipo: ", newValorSelectorTipo);
        console.log("newValorSelectorTipo2: ", newValorSelectorTipo2);
        */

        let newDatosFiltrados= [];
        if (newValorBuscador)
            //newDatosFiltrados= filtrarConTodosCampos(datosIniciales, newValorBuscador);
            newDatosFiltrados= filtrarConCamposGridConfigColumnas(datosIniciales, newValorBuscador, columnas);
        else
            newDatosFiltrados= [...datosIniciales];

        if (newValorSelectorTipo != undefined  && newValorSelectorTipo != 99)
            newDatosFiltrados = filtrarConNombreCampo(newDatosFiltrados, filtroTipoCampoElemento, newValorSelectorTipo);
        if (newValorSelectorTipo2 != undefined  && newValorSelectorTipo2 != 99)
            newDatosFiltrados = filtrarConNombreCampo(newDatosFiltrados, filtroTipo2CampoElemento, newValorSelectorTipo2);

        //console.log("datosFiltrados: ", newDatosFiltrados);


        this.setState({
            datosFiltrados: newDatosFiltrados,
            datosOrdenados: newDatosFiltrados}, () => {
            this.selectRow(0);
        });


        onDatosFiltradosCambiados && onDatosFiltradosCambiados(newDatosFiltrados);
    }

    onFilterChange= (newValorBuscador) => {
        const {valorFiltroTipo, valorFiltroTipo2} = this.state;
        const {onValorBuscadorCambiado} = this.props;


       // console.log("GRID RDG");
       // console.log("onFilterChange: ");
       // console.log("newValorBuscador: ", newValorBuscador);
       // console.log("onValorBuscadorCambiado: ", onValorBuscadorCambiado);


        this.setState({valorBuscador: newValorBuscador});
        onValorBuscadorCambiado && onValorBuscadorCambiado(newValorBuscador);
        this.filtrar(newValorBuscador, valorFiltroTipo, valorFiltroTipo2);

    }

    onKeyUpBuscar= (event) => {
        const{datosFiltrados} = this.state;
        switch (event.keyCode) {
            case 13:
                //console.log(this.refTabla);
                if (datosFiltrados.length > 0){
                    this.refTabla.current.selectCell({idx: 0, rowIdx:0}, false);
                    this.selectRow(0);
                }
                break;
        }
    }

    onSelectorTipoChange= (newValorSelectorTipo) => {
        const { valorBuscador, valorFiltroTipo2} = this.state;
        this.setState({valorFiltroTipo: newValorSelectorTipo});
        this.filtrar (valorBuscador, newValorSelectorTipo, valorFiltroTipo2);
    }

    onSelectorTipo2Change= (newValorSelectorTipo2) => {
        const { valorBuscador, valorFiltroTipo} = this.state;
        this.setState({valorFiltroTipo2: newValorSelectorTipo2});
        this.filtrar (valorBuscador, valorFiltroTipo, newValorSelectorTipo2);
    }

    //------------------------------------------------------------------------------------------------------------------
    // EDIT
    //------------------------------------------------------------------------------------------------------------------
    gridEditable = () => {
        const {columnas} = this.state;
        columnas.forEach( (columna, index) => {
            if (columna.editable && Boolean(columna.editable))
                return true;
        });
        return false;
    }

    //------------------------------------------------------------------------------------------------------------------
    // SELECCION DE CELL
    //------------------------------------------------------------------------------------------------------------------
    selectedCellChange = (location) => {
        const {onSelectedRow, onSelectedCell} = this.props;
        const {datosOrdenados} = this.state;
        let elementoSeleccionado= datosOrdenados[location.rowIdx];
        onSelectedRow && onSelectedRow(elementoSeleccionado);
        onSelectedCell && onSelectedCell(location);
        this.setState({cellSelected : location, elementoSeleccionado: elementoSeleccionado});
    }

    //------------------------------------------------------------------------------------------------------------------
    // SELECCION DE ROW
    //------------------------------------------------------------------------------------------------------------------
    rowClick = (elemento, column) => {
        const {onSelectedRow, rowClickedIsReturn, onRowSelectedReturn} = this.props;
        let elementoSeleccionado= {...elemento};
        //delete elementoSeleccionado.filaSeleccionada; //<<#Nuevo

        this.elementoSeleccionado= {...elemento};
        onSelectedRow && onSelectedRow(elementoSeleccionado);
        if (rowClickedIsReturn && onRowSelectedReturn && !this.gridEditable())
            onRowSelectedReturn && onRowSelectedReturn(elementoSeleccionado);
    }

    selectRow= (row) => {
        //console.log("!!! selectRow:", row);
        const {datosOrdenados} = this.state;
        const {onSelectedRow} = this.props;
        let elemento= null;
        if (row >= 0 && datosOrdenados.length > 0 && row < datosOrdenados.length ) {
            elemento = datosOrdenados[row];
        }
        //console.log("elemento: ", elemento);

        this.setState({selectedRow: row});
        onSelectedRow && onSelectedRow(elemento, row); //#
    }

    //------------------------------------------------------------------------------------------------------------------
    // SELECCCION
    //------------------------------------------------------------------------------------------------------------------
    setSelectedRows= (newSelectedRowsKeys) =>{
        const {checkSeleccionUnico, onSelectedRowsChanged, onComprobarSelectedRows} = this.props;
        const {selectedRowsKeys} = this.state;

        let selectedRowsKeysComprobadas= newSelectedRowsKeys;

        //Comprobamos si son seleccionables
        if (onComprobarSelectedRows) {
            selectedRowsKeysComprobadas = onComprobarSelectedRows(newSelectedRowsKeys);
        }

        if (!checkSeleccionUnico) {
            this.setState({selectedRowsKeys: selectedRowsKeysComprobadas}, () => {
                onSelectedRowsChanged && onSelectedRowsChanged(selectedRowsKeysComprobadas);
            });
        }
        else{
            //buscamos el nuevo
            if (selectedRowsKeys) {
                selectedRowsKeysComprobadas.forEach((rowKey) => {
                    if (!selectedRowsKeys.has(rowKey)) {
                        let newSelectedRowsOneKey = new Set();
                        newSelectedRowsOneKey.add(rowKey);
                        this.setState({selectedRowsKeys: newSelectedRowsOneKey}, () => {
                            onSelectedRowsChanged && onSelectedRowsChanged(newSelectedRowsOneKey);
                        });
                    }
                })
            }
            else{
                this.setState({selectedRowsKeys: selectedRowsKeysComprobadas}, () => {
                    onSelectedRowsChanged && onSelectedRowsChanged(selectedRowsKeysComprobadas);
                });
            }
        }
    }

    //------------------------------------------------------------------------------------------------------------------
    // EDICION
    //------------------------------------------------------------------------------------------------------------------
    onGridRowsChange= (datosModificados, infoModificado, forzarGuardado, noGuardarEnBDD) => {

        /*
        console.log("ONGRIDROWSCHANGE");
        console.log("datos: ", datosModificados);
        console.log("infoModificado: ", infoModificado);
        console.log("column: ", infoModificado.column);
        console.log("indexes: ", infoModificado.indexes);
        */

        const {datosOrdenados, datosIniciales} = this.state;
        const {onRowModificada, listasElementosCombos, onAntesRowGuardar} = this.props;
        let columna = infoModificado.column;
        let datos= datosOrdenados ? datosOrdenados : datosIniciales;
        let newRows = datos.slice();

        let campo = columna.key;
        if (!campo)
            campo = columna.columnKey;
        if (!campo)
            campo = columna.campo;

        infoModificado.indexes.forEach( (i) => {
            let valorOriginal= datos[i][campo];
            let valorNuevo = datosModificados[i][campo];

            //Si se trata de un campo Foreign de modoCargaBDD, el nuevo valor del campo no se obtiene igual:
            if (columna.editorExterno && columna.editorExterno.modoCargaBDDCampoOrigenMostrar) {
                valorNuevo = getValorPropiedad(datosModificados[i], columna.editorExterno.modoCargaBDDCampoOrigenMostrar);
            }


            let valoresCambiados= false;
            if (forzarGuardado && Boolean(forzarGuardado))
                valoresCambiados= true;
            else {
                if (typeof valorNuevo === 'object')
                    valoresCambiados = !compararObjetos(valorOriginal, valorNuevo);
                else
                    valoresCambiados = valorOriginal != valorNuevo;
            }


            if (valoresCambiados) {
                let valido = true;
                let validador = columna.validador;
                if (validador)
                    valido = validador(valorNuevo);
                if (!valido) {
                    valorNuevo = "";
                }

                //Transformacion por tipo
                //console.log("valorNuevo Pre: ", valorNuevo);
                valorNuevo= transformar(columna.tipo, valorNuevo);
                //console.log("valorNuevo Post: ", valorNuevo);

                //¿Hay transformaciones?
                let campoModificar= campo;
                let valorTransformado = valorNuevo;
                if (!columna.clase) {
                    if (columna.tipo === CELLTIPO_CADENA) {
                        //Solo pasamos a mayusculas cuando es una cadena y no es un foreign.
                        valorTransformado = valorNuevo.toUpperCase();
                    }
                }
                else{
                    //Viene en forma CaracteristicaCodigo.nombre, y en el objeto debemos tener el campo caracteristicaCodigo,
                    // para asignar el objeto {codigo:, nombre:}
                    campoModificar= getRaizForeign(campo);
                    //Eliminamos el campo que se ha creado del tipo caracteristicaCodigo.nombre
                    delete datosModificados[campo];
                }

                //Modificamos
                datosModificados[i][campoModificar] = valorTransformado;
                let oldObject = newRows[i];
                newRows[i] = {...newRows[i], ...datosModificados[i], estadoRow: "PENDIENTE"}; //modificamos con el valor de updated: {campo: valor}
                let newObject = newRows[i];
                if (columna.onModificado) {
                    let newObjectModificado = columna.onModificado(newObject);
                    newObject = newObjectModificado ? newObjectModificado : newObject;
                }

                this.forzarRender= {marcaTiempo: new Date()};


                console.log("GRIDRDG  ----->");
                console.log("noGuardarEnBDD: ", noGuardarEnBDD);
                console.log("onRowModificada: ", onRowModificada);
                if (!noGuardarEnBDD || (noGuardarEnBDD && !Boolean(noGuardarEnBDD)) ){
                    if (onRowModificada) {
                        let guardado = onRowModificada(oldObject, newObject, i, this.rowGuardada);
                    }
                }


            }
        });
        this.setState({datosOrdenados: newRows, nuevoElemento: null});
    }

    rowGuardada = (objetoGuardado, rowIndex, correcto) => {
        //console.log("ROW GUARDADA");
        //console.log("correcto -> " + correcto);
        //console.log("objetoGuardado: ", objetoGuardado);

        const {datosOrdenados} = this.state;
        const {onSelectedRow} = this.props;
        let estadoRow = correcto ? "GUARDADO" : "ERROR";
        let newObjetoGuardado = {...objetoGuardado, estadoRow: estadoRow};
        let newDatos = datosOrdenados.slice();
        newDatos[rowIndex] = newObjetoGuardado;
        this.forzarRender= {marcaTiempo: new Date()};
        //console.log(newDatos);

        this.setState({rowsNuevas: 0, nuevoElemento: null, datosOrdenados: newDatos, datosFiltrados: newDatos});

        //!!!!Es necesario para que se actualicen los datos de FormularioGrid y Formulario, y al modificar salgan lso datos actualizados-
        //onSelectedRow && onSelectedRow(rowIndex, newObjetoGuardado);
        //Modificado el 03/06/2022... quitamos el parametro rowIndex
        onSelectedRow && onSelectedRow(newObjetoGuardado);

        //Añadimos el onGuardado----###

    }

    onColumnCellKeyUp = (keyCode, column, valor) => {
        //console.log("ONCOLUMNCELLKEYUP!!!!");
        //console.log("column: ", column);
        //console.log("valor: ", valor);
        if (column.tipo == CELLTIPO_COLOR)
            this.setState({mostrarEditorExterno: EDITOREXTERNO_COLOR,  editorExternoColumn: column});
        if (column.clase){
            this.setState({mostrarEditorExterno: EDITOREXTERNO_FOREIGN,  editorExternoColumn: column});
        }
        if (column.tipo == CELLTIPO_LISTA){
        }
        if (column.tipo == CELLTIPO_IMAGENLISTA){
            //Pasamos a la siguiente imagen
            if (keyCode == 13){
                let posImagen= posPrimerElementoConValorPropiedad(column.imagenes, "valor", valor);
                posImagen++;
                if (posImagen >= column.imagenes.length)
                    posImagen= 0;
                let newValor= column.imagenes[posImagen].valor;
                onListaImagenImagenCambiada(newValor, column, this);
            }
        }
    }

    //------------------------------------------------------------------------------------------------------------------
    // CONFIGURACION
    //------------------------------------------------------------------------------------------------------------------
    configurar = () => {
        //Mostramos el dialogo
        this.setState({mostrarConfiguracion: true});
    }

    onAceptarConfiguracion = (newColumnas, newAlto, algunAnchoModificado) => {
        const {estilo} = this.state;
        let newEstilo= Object.assign(estilo, {height: newAlto + 'px'});

        //por si se ha cambiado a mano el tamaño de alguna columna, debemos sincronizarlos con this.anchosColumnas
        this.anchosColumnas=[];
        newColumnas.forEach((newColumna) => {
            this.anchosColumnas[newColumna.campo]= newColumna.ancho;
        });

        this.setState({mostrarConfiguracion: false,
                             columnas: newColumnas, altoGrid: newAlto, estilo: newEstilo});

        //No se refrescan los tamaños de las columnas si se han modificado con el raton y luego se han modificado con el texto.
        if (algunAnchoModificado && this.algunaColumnaAnchoModificado)
            this.props.funcRefreshData(0, true);

    }

    onCloseConfiguracion = () => {
        this.setState({mostrarConfiguracion: false});
    }


    onColumnResize= (idx, width) => {
        const {columnas} = this.state;
        const {editable, mostrarModificar, mostrarNumeracion} = this.props;

        //let idxColumna=  editable ? idx-1 : idx;
        let idxColumna= idx;
        if (editable || mostrarNumeracion)
            idxColumna-=1; //Si está la columna de la numeración, la columna real es uno menos.
        if (mostrarModificar)
            idxColumna-=1; //Si se muestra la columna con el icono de modificar, la columna real es uno menos.
        let campoNombre= columnas[idxColumna].campo;
        this.anchosColumnas[campoNombre]= width;
        this.algunaColumnaAnchoModificado= true;
    }

    //------------------------------------------------------------------------------------------------------------------
    // MOSTRAR POPOVER
    //------------------------------------------------------------------------------------------------------------------

    //contenidoPopover es el array con el contenido
    mostrarPopover= (objeto, rowIdx, onTooltip) => {
        const {desdeMovil} = this.props;

        //console.log("Conmutar Popover");
        //console.log("objeto: ", objeto);
        //console.log("rowIdx: ", rowIdx);
        //console.log("onTooltip: ", onTooltip);
        if (Boolean(desdeMovil) && onTooltip){
            let contenidoPopover= onTooltip(objeto, rowIdx);
            console.log("contenidoPopover: ", contenidoPopover);
            this.setState({contenidoPopover: contenidoPopover });
        }


    }

    //------------------------------------------------------------------------------------------------------------------
    // CALCULO DE ROWHEIGHTS
    //------------------------------------------------------------------------------------------------------------------

    getRowHeight = (row) => {
        //return this.state.rowHeights.get(row.id) || 35; // altura mínima
        console.log ("oooooooooooooooo   getRowHeight: ");
        return 200;
    };

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    getRowKey= (row) => {
        const {rowKey} = this.props;
        let key= rowKey ? row[rowKey] : null;

        /*
        console.log("XXX getRowkey:  ");
        console.log("rowKey: ", rowKey);
        console.log("key: ", key);
        */

        return key;
    }

    getDatosConRowIdx= (datos) => {
        //console.log("++++ getDatosConRowIdx");
        //console.log("datos: ", datos);
        let newDatos= [...datos];
        newDatos.forEach( (dato, index) => {
            dato.rowIdx= index;
        } );
        return newDatos;
    }

    getDatosConRowSeleccionado= (datos, elementoSeleccionado) => {
       let newDatos= [...datos];
       if (elementoSeleccionado) {
           newDatos.map((row, index) => {
               if (row.codigo == elementoSeleccionado.codigo)
                   row.filaSeleccionada = true;
               else
                   row.filaSeleccionada = false;
           });
       }
       return newDatos;
    }

    copiarPortapapeles= () => {
        const {cellSelected, elementoSeleccionado, datosOrdenados, columnas} = this.state;
        const {editable, mostrarNumeracion, mostrarModificar} = this.props;
        if (!cellSelected || !elementoSeleccionado)
            return;
        console.log("^_^CopiarPortapapeles");
        console.log("elementoSeleccionado: ", elementoSeleccionado);
        console.log("elementoSeleccionado['elementoCodigo']: ", elementoSeleccionado['elementoCodigo']);

        //1º Obtener el campo
        let idxReal= cellSelected.idx;
        if (editable || mostrarNumeracion)
            idxReal-=1; //Si está la columna de la numeración, la columna real es uno menos.
        if (mostrarModificar)
            idxReal-=1; //Si se muestra la columna con el icono de modificar, la columna real es uno menos.
        let campoNombre= columnas[idxReal].campo;
        //let valor= elementoSeleccionado[campoNombre];
        let valor= getValorPropiedad(elementoSeleccionado, campoNombre);


        //Proceso de copia
        if (navigator.clipboard && window.isSecureContext) {
            // navigator clipboard api method'
            return navigator.clipboard.writeText(valor);
        } else {
            // text area method
            let textArea = document.createElement("textarea");
            textArea.value = valor;
            // make the textarea out of viewport
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((res, rej) => {
                // here the magic happens
                document.execCommand('copy') ? res() : rej();
                textArea.remove();
            });
        }

    }

    render() {
        const {datosIniciales, datosOrdenados, columnas, sortDirection, sortColumn,
            selectedRowsKeys, /*elementoSeleccionado,*/ valorBuscador,
            altoGrid, estilo,
            mostrarConfiguracion,  mostrarEditorExterno,
            sortColumns,
            mostrarPopover, contenidoPopover,
            //filtroClickValor,
        } = this.state;
        const {rowKey, showBuscador, mostrarHeaderRow, rowHeight, editable, nivel,
            ifid, usuario, id,
            showFiltroTipo, filtroTipoOpciones, filtroTipoTitulo, filtroTipoCampoElemento,
            filtroTipo2Opciones, filtroTipo2Titulo, filtroTipo2CampoElemento,
            aviso, showNumElementos,
            showFiltroClick, filtroClickTitulo, onChangeFiltroClick, filtroClickValor,
            desdeMovil,
        } = this.props;



        //console.log("GRIDRDG - RENDER");
        //console.log("columnas: ", columnas);
        //console.log("datosOrdenados: ", datosOrdenados);
        //console.log("datosIniciales: ", datosIniciales);


        let buscarStyle=  {marginBottom: '10px'};
        let columnasGrid = null;
        if (columnas) {
           columnasGrid = this.transformarColumnas(columnas, this.resourcesImages, nivel);
        }
        //console.log("columnasGrid: ", columnasGrid);


        let datos= datosOrdenados ? datosOrdenados : datosIniciales;

        //Necesario cuando mostrabamos la linea entera seleccionada
        let newDatos= datos;

        //Metemos en los datos el rowIdx;
        //if (datos.length > 0 && !datos[0].hasOwnProperty("rowIdx"))
        newDatos= this.getDatosConRowIdx(datos);

        //Metemos en las rows de Datos el campo seleccionado para poder usarlo en el formatter.
        if (!editable || !Boolean(editable))
            newDatos= this.getDatosConRowSeleccionado(datos, this.elementoSeleccionado);
        let headerRowHeight= mostrarHeaderRow == null || Boolean(mostrarHeaderRow) ? 30 : 0;
        let rowHeightReal= rowHeight ? rowHeight : 28;
        let inputGroupId= id ? id + "_" + "igBuscador" : "igBuscador";
        let numElementos= showNumElementos && newDatos ? newDatos.length() + " Elementos encontrados." : null;

        //console.log("**** GRIDRDG ----");
        //console.log("desdeMovil: ", desdeMovil);
        //console.log("mostrarPopover: ", mostrarPopover);
        //console.log("conenidoPopover: ", contenidoPopover);
        //console.log("filtroClickValor: ", filtroClickValor);
        //console.log("columnas: ", columnasGrid);

        delete this.forzarRender;
        return(
            <>
                {(showBuscador == undefined || showBuscador === true || showFiltroTipo  == undefined || showFiltroTipo === true) &&
                <div className="grid-contenedorsuperior">
                    {(showBuscador == undefined || showBuscador === true) &&
                    <>
                        <FormGroup label="Buscar" style={buscarStyle} labelFor="igBuscador" inline={true}>
                            <InputGroup
                                id="igBuscador"
                                leftIcon="search"
                                placeholder="Buscar"
                                value={valorBuscador ? valorBuscador : ""}
                                onChange={(event) => this.onFilterChange(event.target.value)}
                                onKeyUp={this.onKeyUpBuscar}
                                inputRef={this.refBuscador}
                            />
                        </FormGroup>
                        <Button icon="clipboard" minimal={true} style={{marginLeft: 4}} onClick={this.copiarPortapapeles} />
                    </>
                    }


                    {((showFiltroTipo == undefined || showFiltroTipo === true) && filtroTipoOpciones) &&
                    <div style={{marginLeft: '20px'}}>
                        <SelectorOpciones
                            opciones={filtroTipoOpciones} inline={true}
                            titulo={filtroTipoTitulo}
                            valorInicial={{codigo: 99, nombre: "Todos"}}
                            onValueChanged={this.onSelectorTipoChange}
                            campoClave="codigo"
                            campoTexto="nombre"/>
                    </div>
                    }

                    {((showFiltroTipo == undefined || showFiltroTipo === true) && filtroTipo2Opciones) &&
                    <div style={{marginLeft: '20px'}}>
                        <SelectorOpciones
                            opciones={filtroTipo2Opciones} inline={true}
                            titulo={filtroTipo2Titulo}
                            valorInicial={{codigo: 99, nombre: "Todos"}}
                            onValueChanged={this.onSelectorTipo2Change}
                            campoClave="codigo"
                            campoTexto="nombre"/>
                    </div>
                    }

                    {Boolean (showFiltroClick) &&
                    <div style={{marginLeft: '20px'}}>
                        <Checkbox
                            style={{paddingTop: 10}}
                            checked={Boolean(filtroClickValor)}
                            onChange={ (event) =>  onChangeFiltroClick(event.target.checked)}>
                            {filtroClickTitulo}
                        </Checkbox>
                    </div>
                    }

                    {aviso && <div className="animacion_aviso">{aviso}</div> }
                    {numElementos && <div className="datagrid_numelementos">{numElementos}</div>}

                </div>
                }

                {(usuario && mostrarConfiguracion) &&
                <Dialog icon="git-push"
                        title={"Configuración"}
                        onClose={this.onCloseConfiguracion}
                        isOpen={mostrarConfiguracion}
                        usePortal={true}
                        style={{width: "60%"}}
                >
                    <ConfiguracionGrid
                        ifid={ifid} usuario={usuario}
                        columnas={this.props.columnas}
                        anchosColumnas={this.anchosColumnas}
                        onAceptar={this.onAceptarConfiguracion} onCancelar={this.onCloseConfiguracion}/>
                </Dialog>
                }

                {mostrarEditorExterno &&  <EditorExterno gridRDG={this} /> }


                {(Boolean(desdeMovil) && contenidoPopover) &&
                <Dialog icon="git-push"
                        title={"Configuración"}
                        onClose={() => this.setState({contenidoPopover: null})}
                        isOpen={contenidoPopover != null}
                        usePortal={true}
                        style={{width: "60%"}}
                >
                    {contenidoPopover}
                </Dialog>
                }

                {datosOrdenados &&
                <div className="grid-contenedor" onKeyUp={this.onKeyUpTabla} tabIndex="-1">

                    {/*}
                    <Popover
                        popoverClassName={Classes.POPOVER_CONTENT}
                        enforceFocus={false}
                        isOpen={this.state.mostrarPopover ? this.state.mostrarPopover : undefined}
                        content={<div>AAA</div>}
                    >
                        <Button intent={Intent.PRIMARY} text="Cerrar" tabIndex={0} />
                    </Popover>
                    */}

                    <DataGrid
                        //className="noHeaderWrapper"
                        className={"datagrid_elemento"}
                        style={estilo}
                        ref={this.refTabla}
                        columns={columnasGrid}
                        rows={newDatos}
                        rowKey={rowKey}
                        onSort={this.sortRows}
                        sortDirection={sortDirection}
                        sortColumn={sortColumn}
                        //onRowsUpdate={this.onGridRowsUpdated}
                        onRowsChange={this.onGridRowsChange}
                        selectedRows={selectedRowsKeys}
                        onSelectedRowsChange={this.setSelectedRows}
                        onRowClick={this.rowClick}
                        headerRowHeight= {headerRowHeight}

                        onSelectedCellChange={this.selectedCellChange}

                        onSortColumnsChange={this.onSortColumns}
                        sortColumns={sortColumns}
                        onColumnResize={this.onColumnResize}

                        rowKeyGetter={this.getRowKey}


                        rowHeight={rowHeightReal}
                        /*
                        rowHeight={row => {
                            // aquí devolvemos altura en px para la fila
                            //const altura = this.state.rowHeights.get(row.id) || 35;
                            //return altura;
                            return 100;
                        }}

                         */
                    />
                </div>
                }
            </>
        );
    }

}



GridRDG.propTypes = {
    columnas: PropTypes.array,
    datos: PropTypes.array,
    rowKey: PropTypes.string,
    ordenable: PropTypes.bool,
    editable: PropTypes.bool,
    showBuscador: PropTypes.bool,
    mostrarChecksSeleccion: PropTypes.bool,
    onSelectedRow: PropTypes.func,
    mostrarFilaActiva: PropTypes.bool,
    elementoSeleccionado: PropTypes.object,
    estilo: PropTypes.object,
    estilizadorRow: PropTypes.func,
    onRowModificada: PropTypes.func,
    mostrarHeaderRow: PropTypes.bool,
    onSelectedRowsChanged: PropTypes.func,
    rowHeight: PropTypes.number,
    ifid: PropTypes.string,
    usuario: PropTypes.object,
    nivel: PropTypes.string,
    onRowSelectedReturn: PropTypes.func,
    rowClickedIsReturn: PropTypes.bool,
    checkSeleccionUnico: PropTypes.bool,
    modificadorValorCelda: PropTypes.func,
    onComprobarSelectedRows: PropTypes.func,
    urlServicioRestful: PropTypes.string,
    usarFiltros35: PropTypes.bool,
    mostrarEncabezado: PropTypes.bool,
    aviso: PropTypes.string,
    showNumElementos: PropTypes.bool,


    onDatosFiltradosCambiados: PropTypes.func,
    onDatosOrdenCambiados: PropTypes.func,
    showFiltroTipo: PropTypes.bool,
    filtroTipoOpciones: PropTypes.array,
    filtroTipoTitulo: PropTypes.string,
    filtroTipoCampoElemento: PropTypes.string,
    filtroTipo2Opciones: PropTypes.array,
    filtroTipo2Titulo: PropTypes.string,
    filtroTipo2CampoElemento: PropTypes.string,

    funcRefreshData: PropTypes.func,

    onDobleClick: PropTypes.func,
    onSelectedCell: PropTypes.func,

    onValorBuscadorCambiado: PropTypes.func,
    valorBuscador: PropTypes.string,
    mostrarNumeracion: PropTypes.bool,

    showFiltroClick: PropTypes.bool,
    filtroClickTitulo: PropTypes.string,
    onChangeFiltroClick: PropTypes.func,
    filtroClickValor: PropTypes.bool,

    mostrarModificar: PropTypes.bool,
    onModificar: PropTypes.func,
    onEliminar: PropTypes.func,

    desdeMovil: PropTypes.bool,
    noFocusInicial: PropTypes.bool,

    mostrarEliminar: PropTypes.bool,
}


const mapStateToProps = function(state) {
    return {
        definicionesif: state.definicionesif
    }
}

//Necesitamos hacer el connect para poder hacer Dispatchs
//export default connect(mapStateToProps)(GridRDG);
export default connect(mapStateToProps, null, null, { forwardRef: true })(GridRDG);
